// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KROi","title":"styles_title__2E83M"};